














































































































import {Vue, Component, VModel, Prop} from 'vue-property-decorator';
import RightSideBar from "@/components/payroll/business/services/RightSideBar.vue";
import {Icon} from "@/components/payroll/business/services/RightSideBar.vue"
import RefContactSliderSelector from "@/components/payroll/business/services/contact/RefContactSliderSelector.vue";
import {
	CreateServiceRecordPayload,
	InvoiceContact, LocationOption,
	ServiceDTO
} from "@/components/payroll/business/services/ServiceDTO";
import ServiceItem from "@/components/payroll/business/services/ServiceItem.vue";
import ServiceSliderSelector from "@/components/payroll/business/services/service/ServiceSliderSelector.vue";
import PortalCheckbox from "@/components/common/PortalCheckbox.vue";
import PortalRadio from "@/components/v2/common/PortalRadio.vue";
import SelectOption from "@/components/common/SelectOption";
import PortalDate from "@/components/common/PortalDate.vue";
import ServiceView from "@/components/payroll/business/services/ServiceView.vue";
import PortalInput from "@/components/common/PortalInput.vue";
import PortalAddress from "@/components/profile/branches/PortalAddress.vue";
import ServiceLogOrchestrator from "@/services/ServiceLogOrchestrator";
import {ifValid, processError} from "@/utils/ComponentUtils";
import Application from "@/state/Application";
import PortalSelect from "@/components/common/PortalSelect.vue";
import Notifications from "@/state/Notifications";
import PortalTextarea from "@/components/common/PortalTextarea.vue";
import LocationSliderSelector from "@/components/payroll/business/services/locations/LocationSliderSelector.vue";
import {IProfile} from "@/dto/IProfile";

@Component({
	computed: {
		SelectOption() {
			return SelectOption
		}
	},
	components: {
		LocationSliderSelector,
		PortalTextarea,
		PortalSelect,
		PortalAddress,
		PortalInput,
		ServiceView,
		PortalDate,
		PortalRadio, PortalCheckbox, ServiceSliderSelector, ServiceItem, RefContactSliderSelector, RightSideBar}
})
export default class ProvideServiceAsContractor extends Vue {
	@VModel({type: Boolean, default: false})
	private model!: boolean;

	@Prop({default: "xmark"})
	private closeIcon!: Icon

	@Prop({default: null})
	private contact!: InvoiceContact | null

	@Prop({default: null})
	private getContact!: null | (() => InvoiceContact | null)

	get internalContact(): IProfile | null {
		if (this.contact) {
			return this.contact
		} else if (this.getContact) {
			return this.getContact()
		} else {
			return null
		}
	}

	@Prop({default: false})
	private dropContact!: boolean

	@Prop({default: true})
	private selectableCurrentProfile!: boolean

	private req = new CreateServiceRecordPayload(
		{
			executorId: this.$wss.getCurrent.id
		}
	)

	private selectedContact: IProfile | null = null;
	private selectedService: ServiceDTO | null = null;
	private selectedLocation: LocationOption | null = null;

	private createContact = false;
	private createService = false;
	private createLocation = false;

	private selectContact(contact: IProfile) {
		this.selectedContact = contact
		this.req.recipientId = this.selectedContact.id
		this.$emit("selectedContact", this.selectedContact)
	}

	private selectService(service: ServiceDTO) {
		this.selectedService = service;
		this.req.serviceId = this.selectedService.id
	}

	private selectLocation(location: LocationOption) {
		this.selectedLocation = location
		this.selectedLocation.selected(this.req)
	}

	mount(visible: boolean) {
		if (this.internalContact) {
			this.selectContact(this.internalContact)
		}
		if (!visible) {
			this.selectedService = null
			this.selectedLocation = null
		}
	}


	private create() {
		if (this.selectedContact == null) {
			Notifications.error("Please select a contact")
			return
		}
		if (this.selectedService == null) {
			Notifications.error("Please select a service")
			return;
		}
		ifValid(this, () => {
			Application.startLoading()
			ServiceLogOrchestrator.createLog(this.req).then(
				res => {
					Application.stopLoading()
					this.$emit("input", false)
					this.$emit("create", res.data)
				},
				err => processError(err, this)
			)
		})
	}
}
